/* eslint-disable react/jsx-key */
import { ReactNode, useState } from 'react';

import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  CaretDownIcon,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  CheckIcon,
  CloseIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  LinkIcon,
  LockIcon,
  MenuIcon,
  MinusIcon,
  MoreIcon,
  NodeLinkAddIcon,
  NodeLinkIcon,
  NodePageAddIcon,
  NodePageIcon,
  PenIcon,
  PlusIcon,
  RenameIcon,
  SaveIcon,
  SettingsIcon,
  TeamAddIcon,
  TeamIcon,
  UnlockIcon,
  UserAddIcon,
  UserIcon,
  WarningIcon,
} from '~components/icons';
import styles from './EditComponents.module.css';

const icons = [
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  CaretDownIcon,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  CheckIcon,
  CloseIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  LinkIcon,
  LockIcon,
  MenuIcon,
  MinusIcon,
  MoreIcon,
  NodeLinkAddIcon,
  NodeLinkIcon,
  NodePageAddIcon,
  NodePageIcon,
  PenIcon,
  PlusIcon,
  RenameIcon,
  SaveIcon,
  SettingsIcon,
  TeamAddIcon,
  TeamIcon,
  UnlockIcon,
  UserAddIcon,
  UserIcon,
  WarningIcon,
];

export const IconsSection = () => {
  const [size] = useState(20);

  return (
    <div className={styles.container}>
      <section>
        <h5>Icons</h5>
        <div className={styles.component}>
          <div className={styles.grid}>
            {icons.map(Icon => (
              <IconWrapper size={size} title={Icon.name}>
                <Icon />
              </IconWrapper>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

const IconWrapper = ({ size, title, children }: { size: number; title?: string; children: ReactNode }) => (
  <div style={{ padding: size }} title={title}>
    <div style={{ height: size, width: size }}>{children}</div>
  </div>
);
